import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../../PartnerOptions/constants'

import { getLicenseInformationError, getLicenseInformationSuccess } from './actions'
import { LICENSE_DATA_REQUEST_ASYNC } from './constants'

const getLicenseInformationEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, LICENSE_DATA_REQUEST_ASYNC.INITIATE),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    }),
    mergeMap(() =>
      api.dashboard.getLicenseInformation(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => getLicenseInformationSuccess(response)),
        catchError((error) => of(epicsErrorHandler(getLicenseInformationError, error))),
        takeUntil(action$.pipe(ofType(LICENSE_DATA_REQUEST_ASYNC.CANCEL)))
      )
    )
  )

export default combineEpics(getLicenseInformationEpic)
